import { AfterContentInit, Component, EventEmitter, Input, OnInit, Output, SimpleChange } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { formatDate, Location } from '@angular/common';
import { DeviceService } from 'src/app/core/services/device.service';
import { EntityService } from 'src/app/core/services/entity.service';
import { Device } from 'src/app/core/models/device.model';
import { Entity } from 'src/app/core/models/entity.model';
import { User } from 'src/app/core/models/user.model';
import * as utils from 'src/app/shared/helpers/utils';
import { ConfigService } from 'src/app/core/services/config.service';

@Component({
  selector: 'hbo-device-actions',
  templateUrl: './device-actions.component.html',
  styleUrls: ['./device-actions.component.scss']
})
export class DeviceActionsComponent implements OnInit, AfterContentInit {

  @Input() device!: Device;
  @Output() reload: EventEmitter<any> = new EventEmitter();

  action = 'create';

  user: User = utils?.localStorageGetItem('user');

  entityId: FormControl<number | null> = new FormControl(null, Validators.required);
  entityBeforeId!: number;

  deviceForm = this.formBuilder.nonNullable.group({
    id: [''],
    deviceTypeId: ['', Validators.required],
    snMac: ['', Validators.required],
    entityId: this.entityId,
    createdAt: ['', Validators.required],
    soldAt: [''],
    hardwareVersion: [''],
    controlUnit: [''],
    irLedType: [''],
    frontendSwVersion: [''],
    backendSwVersion: [''],
    lastActivity: [''],
    serialNumber: [''],
    confirm: false
  });

  utils = utils;
  entities: Entity[] = [];
  childEntities!: Entity[];
  entity!: Entity;
  reactiveToRole: number = 1;

  @Output() callback: EventEmitter<any> = new EventEmitter();
  @Input() selectorVisible!: boolean;
  persistEntityId!: number | null;

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private deviceService: DeviceService,
    private entityService: EntityService,
    private location: Location,
    public configSvc: ConfigService
  ) {
    this.user.childEntities = this.configSvc.currentConfigValue.childEntities;
    this.childEntities = this.user.childEntities!;
    if (this.action === 'create') this.selectorVisible = true;
  }

  ngOnInit() {
    if (!this.device) {
      this.device = { id: 0 } as Device;
    } else {
      this.action = 'edit';
      this.user.roleId !== 1 && this.device.deviceTypeId != 3 ? this.deviceForm.get('serialNumber')?.disable() : null;
      this.deviceForm.get('deviceTypeId')?.disable();
    }

    this.entityService.getOnlyParents().subscribe(entities => this.entities = entities.data);

    if (this.action === 'create') {
      this.reactiveToRole = (this.action == 'create' ? this.user.role!.id : 2);
    }
  }

  ngAfterContentInit() {
    if (this.device && this.device.id !== 0) {
      this.deviceForm.patchValue({
        id: this.device.id?.toString(),
        deviceTypeId: this.device.deviceTypeId?.toString(),
        snMac: this.device.snMac,
        serialNumber: this.device.serialNumber,
        entityId: this.device.entityId,
        createdAt: this.device.createdAt ? formatDate(this.device.createdAt, 'yyyy-MM-dd', 'en') : '',
        soldAt: this.device.soldAt ? formatDate(this.device.soldAt, 'yyyy-MM-dd', 'en') : '',
        hardwareVersion: this.device.hardwareVersion,
        controlUnit: this.device.controlUnit,
        irLedType: this.device.irLedType,
        frontendSwVersion: this.device.frontendSwVersion,
        backendSwVersion: this.device.backendSwVersion,
        lastActivity: this.device.lastActivity ? formatDate(this.device.lastActivity, 'yyyy-MM-dd HH:mm', 'en') : ''
      });

    } else {
      this.deviceForm.patchValue({
        entityId: 1
      });
    }
    this.user.entityId === this.device.entityId
      ? this.entity = this.user.entity
      : this.entity = this.childEntities.find((item: Entity) => item.id == this.device.entityId)!;
  }

  ngOnChanges(change: SimpleChange) {
    this.selectorVisible && !this.persistEntityId
      ? this.persistEntityId = this.device.entityId
      : this.deviceForm.controls.entityId.patchValue(this.device.entityId);
  }

  save() {
    this.deviceForm.markAllAsTouched();
    if (this.deviceForm.valid) {

      this.deviceForm.value.serialNumber = this.deviceForm.value.snMac;

      if (this.action === 'create') {
        this.deviceService.insert({ ...this.deviceForm.value } as unknown as Device).subscribe(res => {
          this.router.navigate(['devices']);
        });
      } else if (this.action === 'edit') {
        /*this.user.entityId === this.device.entityId
          ? this.entity = this.user.entity
          : this.entity = this.childEntities.find((item: Entity) => item.id == this.device.entityId)!;
        alert(this.entity.entityTypeId);
        if (this.entity.entityTypeId === 2) this.deviceForm.controls.confirm.patchValue();*/
        this.entityBeforeId = this.device.entityId;
        if (this.device.entityId != this.deviceForm.controls.entityId.value && this.user.childEntities!.find((entity: Entity) => entity.id === this.entityBeforeId) && this.user.childEntities!.find((entity: Entity) => entity.id === this.entityBeforeId)!.entityTypeId === 4)
          this.deviceForm.controls.confirm.patchValue(false);
        else
          this.deviceForm.controls.confirm.patchValue(true);
        this.deviceService.update({ ...this.deviceForm.value } as unknown as Device).subscribe(res => {
          switch (res.action) {
            case 'confirm':
              this.deviceForm.controls.confirm.patchValue(true);
              let newButton = document.createElement('button');
              newButton.setAttribute('data-bs-toggle', 'modal');
              newButton.setAttribute('data-bs-target', '#confirmationModal-change-device-' + this.deviceForm.controls.id.value);
              document.body.appendChild(newButton);
              newButton.click();
              document.body.removeChild(newButton);
              break;
            default:
              this.persistEntityId = this.deviceForm.controls.entityId.value;
              this.refreshFocusedRows(res);
              //this.reload.emit();
              break;
          }
        });
      }
    }
  }

  confirmSave() {
    this.deviceService.update({ ...this.deviceForm.value } as unknown as Device).subscribe(res => {
      this.persistEntityId = this.deviceForm.controls.entityId.value;
      this.deviceForm.controls.confirm.patchValue(false);
      this.refreshFocusedRows(res);
      //this.reload.emit();
    });
  }

  refreshFocusedRows = (res: any) => {
    this.callback.emit({ action: 'updated', result: res });
  }

  delete() {
    this.deviceService.destroy(this.device.id).subscribe(res => {
      this.reload.emit();
    });
  }

  cancel() {
    if (this.action === 'create') {
      this.location.back();
    } else {
      //this.reload.emit();
      this.setForm();
    }
  }

  setForm() {
    this.deviceForm.patchValue({
      id: this.device.id?.toString(),
      entityId: this.device.entityId,
      snMac: this.device.snMac,
      createdAt: this.device.createdAt ? formatDate(this.device.createdAt, 'yyyy-MM-dd', 'en') : '',
      soldAt: this.device.soldAt ? formatDate(this.device.soldAt, 'yyyy-MM-dd', 'en') : '',
      hardwareVersion: this.device.hardwareVersion,
      controlUnit: this.device.controlUnit,
      irLedType: this.device.irLedType,
      frontendSwVersion: this.device.frontendSwVersion,
      backendSwVersion: this.device.backendSwVersion,
      lastActivity: this.device.lastActivity ? formatDate(this.device.lastActivity, 'yyyy-MM-dd HH:mm', 'en') : ''
    });
    this.persistEntityId = this.device.entityId;
  }

  onChange(id: number, _type?: string) {
    switch (_type) {
      case 'device':
        this.deviceForm.controls.entityId.patchValue(id);
        this.persistEntityId = id;
        break;
      default:
        break;
    }
  }
}
